
import { defineComponent } from "vue";

export default defineComponent({
  props: ["modelValue", "checked"],
  emits: ["update:modelValue"],
});
